import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import $ from 'jquery';
import { toast } from 'react-toastify';
import axiosInstance from '../../config/axiosInterceptor';

const AddPlan = () => {
    const navigate = useNavigate();
    const [themes, setThemes] = useState([]);
    const [frames, setFrames] = useState([]);
    const [selectedTheme, setSelectedTheme] = useState('');
    const [selectedFrame, setSelectedFrame] = useState('');
    const [rs, setRs] = useState(0);
    const [SGST, setSGST] = useState(0);
    const [CGST, setCGST] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const fetchAssets = async () => {
            try {
                const themeRes = await axiosInstance.get(`/admin/plan/getPlanAssets?type=1`);
                const frameRes = await axiosInstance.get(`/admin/plan/getPlanAssets?type=0`);
                if (themeRes.data.success) setThemes(themeRes.data.data);
                if (frameRes.data.success) setFrames(frameRes.data.data);
            } catch (error) {
                toast.error("Error fetching assets: " + error.message);
            }
        };

        fetchAssets();
    }, []);

    useEffect(() => {
        const numericRs = parseFloat(rs) || 0;
        const numericSGST = parseFloat(SGST) || 0;
        const numericCGST = parseFloat(CGST) || 0;
        setTotal(numericRs + numericSGST + numericCGST);
    }, [rs, SGST, CGST]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const title = $("input[name='title']").val();
        const coins = $("input[name='coins']").val();

        if (!title || !coins || !rs) {
            if (!title) $('.form-error1').html("This field cannot be empty");
            if (!coins) $('.form-error2').html("This field cannot be empty");
            if (!rs) $('.form-error3').html("This field cannot be empty");
            return;
        }

        const payload = {
            title,
            coins,
            rs,
            SGST,
            CGST,
            total,
            theme: selectedTheme,
            frame: selectedFrame
        };

        try {
            const res = await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/plan/createPlan`, { data: payload });
            if (res.data.success === 1) {
                toast.success(res.data.message);
                setTimeout(() => navigate('/admin/managePlan'), 1000);
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    const renderSelectedImage = (id, list, isFrame = false) => {
        const selected = list.find(item => item._id === id);
        if (!selected) return null;
        return (
            <img
                src={`${process.env.REACT_APP_BASEURL}${isFrame ? selected.thumbnail : selected.image}`}
                alt={selected.name || selected.title}
                style={{ height: '100px', marginTop: '10px' }}
            />
        );
    };

    return (
        <>
            <section className="content-header">
                <h1>Add Plan</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li><Link to="/admin/managePlan">Manage Plan</Link></li>
                    <li className="active">Add Plan</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={handleSubmit} id="form">
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Add</h3>
                                </div>
                                <div className="box-body">
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" onChange={() => $('.form-error1').html('')} />
                                        <div className="form-error1 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Coin*</label>
                                        <input type="number" className="form-control" name="coins" onChange={() => $('.form-error2').html('')} />
                                        <div className="form-error2 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Rupees (INR)*</label>
                                        <input type="number" className="form-control" name="rs" value={rs} onChange={(e) => { setRs(e.target.value); $('.form-error3').html(''); }} />
                                        <div className="form-error3 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>SGST</label>
                                        <input type="number" className="form-control" value={SGST} onChange={(e) => setSGST(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label>CGST</label>
                                        <input type="number" className="form-control" value={CGST} onChange={(e) => setCGST(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label>Total Amount</label>
                                        <input type="number" className="form-control" value={total} readOnly />
                                    </div>

                                    <div className="form-group">
                                        <label>Select Theme</label>
                                        <select className="form-control" value={selectedTheme} onChange={(e) => setSelectedTheme(e.target.value)}>
                                            <option value="">-- Select Theme --</option>
                                            {themes.map(theme => (
                                                <option key={theme._id} value={theme._id}>
                                                    {theme.name ?? "THEME"} - {theme.valid} hours
                                                </option>
                                            ))}
                                        </select>
                                        {renderSelectedImage(selectedTheme, themes)}
                                    </div>

                                    <div className="form-group">
                                        <label>Select Frame</label>
                                        <select className="form-control" value={selectedFrame} onChange={(e) => setSelectedFrame(e.target.value)}>
                                            <option value="">-- Select Frame --</option>
                                            {frames.map(frame => (
                                                <option key={frame._id} value={frame._id}>
                                                    {frame.title ?? "FRAME"} - {frame.valid} hours
                                                </option>
                                            ))}
                                        </select>
                                        {renderSelectedImage(selectedFrame, frames, true)}
                                    </div>

                                    <div className="form-group">
                                        <button type="reset" className="btn btn-danger">Cancel</button>
                                        <input type="submit" className="btn btn-success pull-right" value="Submit" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AddPlan;
